export const contactTR = {
    "mustHaveChar": "En az iki karakter içermelidir",
    "less255": "255 karakterden kısa olmalıdır",
    "required": "Zorunlu alan",
    "invalidEmail": "Geçersiz e-posta",
    "invalidPhone": "Geçersiz telefon numarası",
    "textareaMax": "1000 karakterden kısa olmalıdır",
    "contactForm": "İletişim Formu",
    "firstName": "Ad",
    "lastName": "Soyad",
    "phone": "Telefon",
    "email": "E-posta",
    "text": "Mesaj",
    "buttonForm": "Gönder",
    "emailSent": "E-posta gönderildi!",
    "emailSentMessage": "E-postanız başarıyla gönderildi!",
    "emailError": "E-posta Hatası!",
    "emailErrorMessage": "E-postanız gönderilemedi!"
}